import { Box, Typography } from "@mui/material";
import { BrandSpinner } from "./BrandSpinner";

export function BrandLoader({
  label = "Loading records...",
}) {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 10,

        display: "grid",
        placeItems: "center",

        width: "100%",
        height: "100%",
        minHeight: 320,

        bgcolor: "rgba(255, 255, 255, 0.96)",
      }}
    >
      <Box
        sx={{
          display: "grid",
          justifyItems: "center",
          textAlign: "center",
        }}
      >
        <BrandSpinner size={100} />

        <Typography
          sx={{
            mt: 1.5,
            color: "#475467",
            fontSize: "0.74rem",
            fontWeight: 800,
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
}